import React from "react"
import Section from "./section"
import DfbBreadcrumbs from "../ui-kit/dfb_breadcrumbs"

const MBreadcrumb = (props) => {
  return (
    <Section baseClass="m-Breadcrumb" data={props.data}>
      <div className="m-Breadcrumb-wrapper">
        <div className="m-Breadcrumb-container">
          <div className="m-Breadcrumb-content">
            <DfbBreadcrumbs {...props} />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MBreadcrumb
